import React, { createContext, useMemo, useEffect, useContext } from 'react'

import { useAuth } from 'contexts/auth/AuthContext'
import { useOrg } from 'contexts/OrgContext'
import useLegalEntity from 'hooks/data/legalEntityHook'
import useFeatureFlags from 'hooks/feature-flags/useFeatureFlags'

export function useLegalEntityContext() {
  return useContext(LegalEntityContext)
}

export const LegalEntityContext = createContext({})

export const LegalEntityProvider = ({ children }: { children: React.ReactNode }) => {
  const { org, setOrg } = useOrg()
  const { isLoading } = useAuth()
  const { entityData, rootOrg } = useLegalEntity({ enabled: !isLoading })
  const { shouldShowAllLegalEntityText } = useFeatureFlags()
  const shouldSetFirstChild =
    rootOrg === org && entityData && entityData.length > 0 && shouldShowAllLegalEntityText

  // we just want to set the child if the parent loads and it is part of the flag
  useEffect(() => {
    if (entityData && org && shouldSetFirstChild) {
      const firstChild = entityData[0]
      setOrg(firstChild)
    }
  }, [org, entityData, setOrg, shouldShowAllLegalEntityText, shouldSetFirstChild])

  const value = useMemo(() => ({}), [])

  return <LegalEntityContext.Provider value={value}>{children}</LegalEntityContext.Provider>
}
